angular.
module("dx.webapp.api").
factory("dxApiV1Groups", function apiV1GroupsService(
	$http,
	$window
) {
	"use strict";

	var url = "/api/v1/groups";

	function groupsGet(ids) {
		var queryParams = {};

		if (ids) {
			queryParams.id = ids.join(",");
		}

		var queryString = $window.jQuery.param(queryParams);
		return $http.get(url + (queryString ? "?" + queryString : "")).then(function success(response) {
			return response;
		});
	}

	function addMembers(id, emails, ravenSuppressCodes) {
		return $http.post(url + "/" + id + "/addmembers", emails, {ravenSuppressCodes: ravenSuppressCodes});
	}

	return {
		get: groupsGet,
		addMembers: addMembers,
	};
});
